import React from 'react';

import { Link as RouterLink } from '~/lib/react-router-dom';

import { Link } from '@mui/material';

import { flashPropertyPath } from './utils';

interface Props {
  propertyId: string;
  vendorId?: string;
}

// The flash property's page needs its vendor; without one the id is shown unlinked.
export default function CompetitorOfferPropertyLink({ propertyId, vendorId }: Props) {
  if (!vendorId) {
    return <>{propertyId}</>;
  }
  return (
    <Link
      component={RouterLink}
      to={flashPropertyPath(vendorId, propertyId)}
      target="_blank"
      rel="noopener noreferrer"
      variant="body2"
    >
      {propertyId}
    </Link>
  );
}
